module.exports = __webpack_public_path__ + "assets/img/banner-17.fd4d0030.jpg";